import styled from '../../styles/styled';
import { space } from 'styled-system';
import { Row } from '../layout';
export const InfoIconContainer = styled.div(({ theme }) => {
    return {
        border: `1px solid ${theme.colors.grey90}`,
        borderRadius: '100px',
        display: 'inline-block',
    };
}, space);
export const InfoIconRow = styled(Row)({
    justifyContent: 'start',
    alignItems: 'center',
}, space);
//# sourceMappingURL=info_icon.styles.js.map